module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "emissions_de_CO2.f982f30e.svg";